<template>
    <NegociosShell>
        <NegociosHero @anunciarme="irARegistro()" @ir-a="irA" />
        <NegociosBeneficios />
        <NegociosComoFunciona />
        <NegociosPlanes @anunciarme="irARegistro()" @elegir-plan="irARegistro" />
        <NegociosFaq />
        <NegociosContacto @anunciarme="irARegistro()" />
        <NegociosCtaFinal @anunciarme="irARegistro()" />
    </NegociosShell>
</template>

<script>
import NegociosShell from './NegociosShell';
import NegociosHero from './components/NegociosHero';
import NegociosBeneficios from './components/NegociosBeneficios';
import NegociosComoFunciona from './components/NegociosComoFunciona';
import NegociosPlanes from './components/NegociosPlanes';
import NegociosFaq from './components/NegociosFaq';
import NegociosContacto from './components/NegociosContacto';
import NegociosCtaFinal from './components/NegociosCtaFinal';
import { irASeccion } from './navegacion';
import { aplicarSeo, limpiarSeo } from './seo';

export default {
    name: 'NegociosLanding',
    components: {
        NegociosShell,
        NegociosHero,
        NegociosBeneficios,
        NegociosComoFunciona,
        NegociosPlanes,
        NegociosFaq,
        NegociosContacto,
        NegociosCtaFinal
    },
    mounted() {
        aplicarSeo({
            titulo: 'Seway Plus Negocios | Publicidad para conductores en ruta',
            descripcion:
                'Publicita tu restaurante, hotel, montallantas, estación de servicio y negocio ante conductores de carga que circulan cerca de tu establecimiento.',
            imagen: 'layout/images/hero-truck-bg.png'
        });

        // El header y el footer mandan ?ir=<seccion> cuando se navega desde otra
        // ruta. Se espera al siguiente tick para que las secciones ya estén en el DOM.
        const destino = this.$route.query.ir;
        if (destino) {
            this.$nextTick(() => irASeccion(destino));
        }
    },
    unmounted() {
        limpiarSeo();
    },
    methods: {
        irA(id) {
            irASeccion(id);
        },
        /**
         * Puerta de entrada al flujo de anunciante. El plan elegido viaja como
         * query param para precargarlo del otro lado.
         */
        irARegistro(codigoPlan) {
            const destino = { path: '/negocios/registro' };
            if (codigoPlan) {
                destino.query = { plan: codigoPlan };
            }
            this.$router.push(destino);
        }
    }
};
</script>
